document.querySelectorAll('.saam-footer').forEach(footer => {
 const wide = matchMedia('(min-width:750px)');
 const groups = [...footer.querySelectorAll('.saam-footer__links')];
 const update = () => groups.forEach(group => { group.open = wide.matches; group.querySelector('summary').tabIndex = wide.matches ? -1 : 0; });
 update(); wide.addEventListener('change', update);
 groups.forEach(group => group.addEventListener('toggle', () => { if (wide.matches && !group.open) group.open = true; }));
});
